import { jsxs as i, jsx as n } from "react/jsx-runtime";
import f from "clsx";
import "../../utils/sectionPreview.js";
import "react";
import "../Button/Button.js";
import { Space as b } from "../Space/Space.js";
import { CloseIcon as u } from "../../icons/CloseIcon.js";
import { ErrorIcon as h } from "../../icons/ErrorIcon.js";
import { InfoIcon as g } from "../../icons/InfoIcon.js";
import { SuccessIcon as w } from "../../icons/SuccessIcon.js";
import { WarningIcon as z } from "../../icons/WarningIcon.js";
import "next/link";
import "../../_chunks/RadioRatingStarButton.Brs_PIli.js";
import "js-cookie";
import "../Combobox/Combobox.js";
import "../Datepicker/Datepicker.js";
import { Typography as e } from "../Typography/Typography.js";
import "@portabletext/react";
import "../Grid/Col/Col.js";
import "react-is";
import "../IconButton/IconButton.js";
import "next/image";
import "../Input/Input.js";
import "@hookform/error-message";
import "../Modal/constants.js";
import "../Modal/ModalContent.js";
import "../Modal/ModalFooter.js";
import "../Modal/ModalHeader.js";
import "../Modal/ModalContext.js";
import "../RadioButton/RadioButton.js";
import "../Switch/Switch.js";
import '../../_assets/Banner.DwoqHTl_.css';const I = "_banner_nxxc9_44", N = "_icon_nxxc9_53", v = "_mainContent_nxxc9_66", y = "_message_nxxc9_79", C = "_children_nxxc9_84", T = "_btn_nxxc9_90", k = "_disabled_nxxc9_113", j = "_warning_nxxc9_141", B = "_info_nxxc9_148", P = "_error_nxxc9_155", S = "_success_nxxc9_162", o = {
  banner: I,
  icon: N,
  mainContent: v,
  message: y,
  children: C,
  btn: T,
  disabled: k,
  warning: j,
  info: B,
  error: P,
  success: S,
  "slide-in-out": "_slide-in-out_nxxc9_1",
  "fade-in-out": "_fade-in-out_nxxc9_1"
}, W = {
  warning: /* @__PURE__ */ n(z, { size: 24 }),
  info: /* @__PURE__ */ n(g, { size: 20 }),
  error: /* @__PURE__ */ n(h, { size: 20 }),
  success: /* @__PURE__ */ n(w, { size: 20 })
}, xn = ({
  variant: t,
  icon: m,
  label: s,
  text: r,
  withIcon: a = !0,
  withBtn: p,
  onClick: _,
  className: x,
  children: c
}) => {
  const d = f(o.banner, o[`${t}`], x), l = m || W[t];
  return /* @__PURE__ */ i("div", { className: d, children: [
    a && /* @__PURE__ */ n("span", { className: o.icon, children: l }),
    /* @__PURE__ */ i("div", { className: o.mainContent, children: [
      /* @__PURE__ */ i("div", { className: o.message, children: [
        s && /* @__PURE__ */ n(b, { bottom: r ? { xxs: 4, s: 8 } : 0, children: /* @__PURE__ */ n(e, { variant: "portalText", weight: "700", size: "1", color: "black-new", noPadding: !0, children: s }) }),
        r && /* @__PURE__ */ n(e, { variant: "portalText", size: "2", noPadding: !0, color: "black-new", children: r })
      ] }),
      c && /* @__PURE__ */ n("div", { className: o.children, children: c })
    ] }),
    p && /* @__PURE__ */ n("button", { type: "button", onClick: _, className: o.btn, children: /* @__PURE__ */ n(u, { size: 20, strokeWidth: 1.5 }) })
  ] });
};
export {
  xn as Banner
};
